<template>
  <div class="d-flex flex-column align-items-center justify-content-center mt-5 mb-5">
    <div class="row">
      <b-spinner type="grow" style="width: 3rem; height: 3rem;" />
    </div>
    <div v-if="text" class="row">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: null,
    },
  },
};
</script>
